import apiClient from '@/utils/request'
import { nestedQueryFormatter } from '@/utils/query'
import { IVerticalResponse } from '@/interfaces/verticals'

export const fetchItems = async (): Promise<IVerticalResponse> => {
  const params = Object.assign(
    { limit: 100, start: 0 },
    nestedQueryFormatter('sorter', { direction: 'asc', field: 'title' })
  )

  const response = await apiClient.get<IVerticalResponse>('/verticals', {
    params
  })
  return response.data
}
